import { useEffect } from "react";

declare const ANALYZER_URL: string | undefined;

function RedirectToAnalyzer() {
  useEffect(() => {
    if (ANALYZER_URL) {
      window.location.href = `${ANALYZER_URL}${window.location.pathname}${window.location.search}`;
    }
  }, []);

  return null;
}

export { RedirectToAnalyzer };
